
function processTemplateValues(template, values) {
    for (let name in values) {
        template = template.replace(new RegExp(`@${name}@`, 'g'), values[name]);
    }
    return template;
}

export default processTemplateValues;
